import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type PropType } from 'vue';

import type { Toast } from './toast-manager';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastWrapper',
  props: {
  toast: {
    type: Object as PropType<Toast & { internalId: string }>,
    required: true,
  },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const order = computed(() => props.toast.order);
const duration = computed(() => props.toast.duration || 3000);
const toastId = computed(() => props.toast.internalId);

let activeTimeout: number | null = null;

const disableAutoRemove = () => {
  if (!activeTimeout) {
    return;
  }

  clearTimeout(activeTimeout);
  activeTimeout = null;
};

const remove = () => {
  disableAutoRemove();
  emit('remove', {
    id: toastId.value,
    order: order.value,
  });
};

const setupAutoRemove = () => {
  activeTimeout = window.setTimeout(remove, duration.value);
};

const onMouseEnter = () => {
  disableAutoRemove();
};

const onMouseLeave = () => {
  setupAutoRemove();
};

setupAutoRemove();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.toast.content), _mergeProps({
    id: toastId.value,
    class: "toast-wrapper"
  }, __props.toast.props, {
    onRemove: remove,
    onFocusin: onMouseEnter,
    onFocusout: onMouseLeave,
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave
  }), null, 16, ["id"]))
}
}

})